import React, { useState } from 'react';
import { Button, Modal, notification } from 'tea-component';
import { useIntl } from 'umi';
import { deleteEventItem } from '@/pages/dashboard/services/event';

interface deleteEventProps { 
  showDeleteModal: boolean;
  gameCode: string;
  deleteEvent: any;
  close:any;
  getTableData:any 
}

export default (props:deleteEventProps ) => {
  const { showDeleteModal, gameCode, deleteEvent,close,getTableData } = props;
  const { id, event_title_en } = deleteEvent || {};
  const { formatMessage } = useIntl();

  const deleteEventFunc = () => {
    deleteEventItem({ game_code:gameCode, id }).then(() => {
      notification.success({
        description: formatMessage({ id: 'event_delete_success' }),
        className: 'filter-lock-alert',
        duration: 1000
      })
      getTableData()
      close()
    }).catch((err) => {
      notification.error({
        description: formatMessage({ id: 'event_delete_error' }),
        className: 'filter-lock-alert',
        duration: 1000
      })
    })
  }

  return <>
    <Modal visible={showDeleteModal} caption='' onClose={close}>
      <Modal.Body>
        <div className="deleteSetting-title">{formatMessage({ id: 'event_delete_event' })}</div>
        <div className="deleteSetting-desc">{formatMessage({ id: 'event_delete_sure' }, { name: <span className='dbd_filter_save_delete_name'>{event_title_en}</span> })}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={deleteEventFunc}>
          {formatMessage({ id: 'common_confirm' })}
        </Button>
        <Button type="weak" onClick={close}>
          {formatMessage({ id: 'common_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

